import { render, staticRenderFns } from "./warrantyLayout.pug?vue&type=template&id=6cd6c93a&lang=pug&"
import script from "./warrantyLayout.js?vue&type=script&lang=js&"
export * from "./warrantyLayout.js?vue&type=script&lang=js&"
import style0 from "./warrantyLayout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd6c93a')) {
      api.createRecord('6cd6c93a', component.options)
    } else {
      api.reload('6cd6c93a', component.options)
    }
    module.hot.accept("./warrantyLayout.pug?vue&type=template&id=6cd6c93a&lang=pug&", function () {
      api.rerender('6cd6c93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/index.vue"
export default component.exports